import { addDoc, collection, doc, getDoc, serverTimestamp, updateDoc } from 'firebase/firestore'
import { db } from '@/firebase'

export const checkoutRequestService = {
  async createSubscriptionRequest({
    userUid,
    userEmail,
    customerId,
    customerName,
    plan,
    branchId = null,
  }) {
    if (!userUid) throw new Error('userUid is required')
    if (!customerId) throw new Error('customerId is required')
    if (!plan?.id) throw new Error('plan is required')

    const payload = {
      type: 'subscription',
      status: 'pending',
      userUid,
      userEmail: userEmail || null,
      customerId,
      customerName: customerName || null,
      planId: plan.id,
      planCode: plan.code || null,
      planName: plan.name || null,
      amount: Number(plan.amount || 0),
      washesIncluded: plan.washesIncluded ?? 'unlimited',
      durationDays: Number(plan.durationDays || 0),
      eligibleServiceIds: Array.isArray(plan.eligibleServiceIds) ? plan.eligibleServiceIds : [],
      branchId,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    }

    const ref = await addDoc(collection(db, 'checkoutRequests'), payload)
    return ref.id
  },

  async getRequestById(id) {
    const snap = await getDoc(doc(db, 'checkoutRequests', id))
    return snap.exists() ? { id: snap.id, ...snap.data() } : null
  },

  async markProcessed(id, { processedByUid }) {
    await updateDoc(doc(db, 'checkoutRequests', id), {
      status: 'processed',
      processedAt: serverTimestamp(),
      processedByUid: processedByUid || null,
      updatedAt: serverTimestamp(),
    })
  },
}

